
import Embedwidget from './embedwidget.js';
export { Embedwidget };

const domReady = function(callback) {    
    document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};


const bi = function(selector)
{ 
 return new Embedwidget(selector);
};


domReady(function() {  

const _biwidgetunit = bi('[data-aculistwidget]');
if (_biwidgetunit.selector !== null) { 
  _biwidgetunit.injectIframe();
}
});
